<template>
	<div>
		<div class="back_img hidden-xs-only hidden-sm-only">
			<div class="content">
				<headers></headers>
				<div class="mt-50 b_bai br5 h-500">
					<div class="t_c p-30 fb f-20">查询结果</div>
					<table class="table">
						<tr class="tr_top">
							<td>序号</td>
							<td>姓名</td>
							<td>身份证号</td>
							<td>证书编号</td>
							<td>培训日期</td>
							<td>所属公司</td>
							<td>人员类别</td>
							<td>类型</td>
						</tr>
						<tr class="tr_bottom" v-for="(item,index) in list" :key="index">
							<td>{{index + 1}}</td>
							<td>{{item.name}}</td>
							<td>{{item.idcard}}</td>
							<td>{{item.issue_unit}}</td>
							<td>{{item.train_time}}</td>
							<td>{{item.cert_no}}</td>
							<td>{{item.belong}}</td>
							<td>{{item.type}}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		<div class="hidden-lg-and-up mobile_style">
			<div class="search_value" v-for="(item_mobile,index_mobile) in list" :key="index_mobile">
				<div class="t_c f-wb f-18">查询结果</div>
				<div class="f-wb f-16">姓名：</div>
				<div class="mobile_content">{{item_mobile.name}}</div>
				<div class="f-wb f-16">身份证号：</div>
				<div class="mobile_content">{{item_mobile.idcard}}</div>
				<div class="f-wb f-16">证书编号：</div>
				<div class="mobile_content">{{item_mobile.issue_unit}}</div>
				<div class="f-wb f-16">培训日期：</div>
				<div class="mobile_content">{{item_mobile.train_time}}</div>
				<div class="f-wb f-16">所属公司：</div>
				<div class="mobile_content">{{item_mobile.cert_no}}</div>
				<div class="f-wb f-16">人员类别：</div>
				<div class="mobile_content">{{item_mobile.belong}}</div>
				<div class="f-wb f-16">类型：</div>
				<div class="mobile_content">{{item_mobile.type}}</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import 'element-ui/lib/theme-chalk/display.css';
	import headers from './common/header.vue'
	export default {
		components:{
			headers
		},
		data(){
			return{
				list:[]
			}
		},
		mounted(){
			console.log(this.$route.query)
			this.getInfo()
		},
		methods:{
			getInfo(){
				this.list = this.$route.query.info
			}
		}
	}
</script>

<style scoped>
	.table{
		width: 90%;
		margin:0 5%;
	}
	table tr td{
		border:1px solid #c4d0f0;
		text-align:center;
		padding:10px 10px;
		color:#4f93fe;
	}
	.tr_top{
		background-color: #dfe8fd;
	}
	.tr_bottom{
		background-color: #f9faff;
	}
	.mobile_style{
		padding:0 10px;
		line-height:30px;
	}
	.mobile_content{
		color:#333;
		font-size: 15px;
	}
	.search_value{
		border:1px solid #cecece;
		padding:15px;
		margin-top: 20px;
	}
</style>


